import React, { useState } from 'react';
import "./Home2.css"
import dark_arrow from "../../assets/logo/dark-arrow.png"
import Gallery from '../Gallery/Gallery'



const Home2 = ({ onButtonClick, galleryTitle="Gallery" }) => {

    const [readMore, setReadMore] = useState(false)

  return (
    <div className='hero container'>
        <div className="hero-text">
          {/* <h2>Co-founder</h2> */}
          <h1>TEACHING JOURNEY</h1>
          <p className='eduzolve-mission'>
          LOVEWORLD INTERNATIONAL SCHOOL
            <br /> <br />
            {readMore && (
                <p className='eduzolve-mission'>
                After tertiary education, I got my first opportunity to teach both mathematics and integrated science for four 
                academic years (2015 - 2018) at LOVEWORLD INTERNATIONAL SCHOOL belonging to pastor Chris’s loveworld Ministry 
                along the Tema Beach Road opposite the Regional Maritime University. During the four years period, the school was 
                always ranked among the top 5 best schools in terms of academics as far as Basic Education Certificate Examination results were concerned. 
                
                <br /> <br />
                The two major roles i played in the school were;  ......
                </p>
            )}
          </p>
          {/* <a href="https://www.uef.fi/en/article/from-west-africa-to-finland-for-higher-education-and-entrepreneurship-peter-and-oluseguns" target='_blank'>
            <button className='btn'>Read more<img src={dark_arrow} alt="" /> </button>
          </a> */}
          <button onClick={() => {setReadMore(!readMore)}} className='btn more-gallery'> {readMore ? "Show less": "Read more"}  {readMore ? null : <img src={dark_arrow} alt="" /> } </button>
          {/* <button onClick={onButtonClick} className='btn more-gallery'>{galleryTitle}</button> */}
          {/* <Gallery/> */}
        </div>
    </div>
  )
}

export default Home2


